import {Component, Input} from '@angular/core';

@Component({
  selector: 'gd-top-toolbar',
  templateUrl: './top-toolbar.component.html',
  styleUrls: ['./top-toolbar.component.less']
})
export class TopToolbarComponent {

  constructor() {
  }
}
